import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';
import { MessageService } from '@services/helpers/message-service/message.service';
import { QuotesDataProvider } from '@services/quote/quotes-data-service/quotes.data.service';

@Component({
	selector: 'modal-delete-quote',
	template: require('./modal-delete-quote.html')
})
export class ModalDeleteQuoteComponent {
	@Input() jobId;
	@Input() leadId;
	@Input() quoteId;
	@Input() isLead;
	disableButtons: boolean;

	constructor(
		private messageService: MessageService,
		private quotesDataService: QuotesDataProvider,
		private location: Location
	) {}

	ngAfterViewInit() {}
	deleteQuote(): void {
		this.disableButtons = true;

		this.quotesDataService
			.deleteQuote(this.jobId, this.quoteId)
			.finally(() => (this.disableButtons = false))
			.subscribe(
				() => {
					this.messageService.showToaster('s_5', 'payments');
					if (this.isLead === true) {
						this.location.go(`leads/view/${this.leadId}`);
					} else {
						this.location.go(`jobs/view/${this.jobId}`);
					}
					$('#deleteQuoteModal').modal('hide');
				},
				error => this.messageService.showDefaultErrorMessage(error)
			);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/quote/modals/modal-delete-quote/modal-delete-quote.ts